import { FC } from 'react';
import styled from 'styled-components';

import { getAddressDisplay } from '@/shared/helpers/addresses';
import { Address as AddressType } from '@/shared/lib/forms/form-wrapper.types';

import { CopyButton } from '../CopyButton';

type AddressProps = {
  value: AddressType;
  isPdf?: boolean;
};

const EMPTY_TEXT = '-';

export const Address: FC<AddressProps> = ({ value, isPdf }) => {
  const text = getAddressDisplay(value, EMPTY_TEXT);

  if (!value || text === EMPTY_TEXT) {
    return EMPTY_TEXT;
  }

  if (isPdf) {
    return text;
  }

  return (
    <Container>
      {text}
      <CopyButton
        text={text}
        successMessage="Address copied to clipboard"
        errorMessage="Failed to copy address"
      />
    </Container>
  );
};

const Container = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;
